import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Header from './components/Header';
import HeroSection from './components/HeroSlider';
import About from './pages/About';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import BookingBannerSection from './pages/BookingBannerSection';
import Ourfleet from './pages/OurFleets';
import Footer from './components/Footer';
import Packages from './pages/Packages';
import Booking from './pages/Booking';
import ContactSection from './pages/ContactSection';
import Enquiry from './pages/Enquiry';
import Gallery from './pages/Gallery';
import Onlinecabbookinginpune from './pages/Online Cab Booking in Pune';
import ScrollToTop from './components/ScrollToTop';
import Punetokolhapurcab from './pages/Pune to Kolhapur Cab';
import Punetosataracab from './pages/Pune to Satara Cab';
import Punetohyderabad from './pages/Pune to Hyderabad Cab';
import Punetobanglorecab from './pages/Pune to Bangalore Cab';
import Punetoindorecab from './pages/Pune to Indore Cab';
import Punetogujratcab from './pages/Pune to Gujarat Cab';
import Punetolonavala from './pages/Pune to Lonavala Taxi';
import Punetojejuricab from './pages/Pune to Jejuri Cab';
import Localtaxiserviceinpune from './pages/Local Taxi Service in Pune';
import Punetolavasacab from './pages/Pune to Lavasa Cab';
import Punetokashidbeach from './pages/Pune to Kashid Beach Cab';
import Onewaycabpune from './pages/One Way Cab Pune';
import Roundtripcab from './pages/Round Trip Cab';
import Taxiservicenearme from './pages/Taxi Service Near Me';
import Carhireinpune from './pages/Car Hire in Pune';
import Seatercarrentalinpune from './pages/Seater Car on Rent in Pune';
import Cabserviceinpimprichichwad from './pages/Cab Service in Pimpri Chinchwad';
import Punetotaxicabservice from './pages/Pune Taxi Cab Services';
import Puneairporttaxi from './pages/Pune Airport Taxi';
import Punetorajshthancab from './pages/Pune to Rajasthan Cab';
import Punetomatherancab from './pages/Pune to Matheran Cab';
import Punetopandharpurcab from './pages/Pune to Pandharpur Cab';
import Punetomumbaicabs from './pages/Pune to Mumbai Cabs';
import Punetomumbaiairportcab from './pages/Pune to Mumbai Airport Cab';
import Punetomumbaitaxi from './pages/Pune to Mumbai Taxi';
import Mumbaitopunecab from './pages/Mumbai to Pune Cab';
import Mumbaiairporttopunecab from './pages/Mumbai Airport to Pune Cab';
import Dadartopunecabservice from './pages/Dadar to Pune Cab Service';
import Bandratopunecabs from './pages/Bandra to Pune Cab';
import Punrtooutstationcab from './pages/Pune to Outstation Cab';
import Taxiserviceinpune from './pages/Taxi Service in Pune';
import Punetoshirditaxifare from './pages/Pune to Shirdi Taxi Fare';
import Puneairporttoshirdicab from './pages/Pune Airport to Shirdi Cab';
import Punetonashikcab from './pages/Pune to Nashik Cab';
import Punetobhimashankarcab from './pages/Pune to Bhimashankar Cab';
import Punetotrimbakeshwarcab from './pages/Pune to Trimbakeshwar Cab Fare';
import Punetomahabaleshwarcab from './pages/Pune to Mahabaleshwar Cab';
import Punetopanchganicab from './pages/Pune to Panchgani Cab';
import Punetoahmednagarcab from './pages/Pune to Ahmednagar Cab';
import Punetogoataxi from './pages/Pune to Goa Taxi';
import Punetoalibaugcab from './pages/Pune to Alibaug Cab';
import Punetoashtavinayakcab from './pages/Pune to Ashtavinayak Cab';
import Punetoaurangabadcab from './pages/Pune to Aurangabad Cab';
import Andheritopunecab from './pages/Andheri to Pune Cab';
import Borivalitopunecab from './pages/Borivali to Pune Cab';
import Mumbaitolonavalacab from './pages/Mumbai to Lonavala Cab';
import Navimumbaitopunecab from './pages/Navi Mumbai to Pune Cab';
import Thanetopunecab from './pages/Thane to Pune Cab';
import Sedancabserviceinpune from './pages/Sedan Cab Service in Pune';
import Innovacrystacabbooking from './pages/Innova Crysta Cab Booking';
import Ertigacabpune from './pages/Ertiga Cab Pune';
import Tempotravelleeronrentinpune from './pages/Tempo Traveller on Rent Pune';
import Minibusonrent from './pages/Mini Bus on Rent';
import ContactButtons from './components/ContactButtons';
import Punetomumbaiinternatinalairport from './pages/Pune to Mumbai International Airport Cab';
import Punetomumbaionewaycabservice from './pages/Pune to Mumbai One Way Cab Service';
import Punetomumbaicarhire from './pages/Pune Mumbai Car Hire';
import Punetomumbaitaxifare from './pages/Pune to Mumbai Taxi Fare';
import Punetomumbaionlinecabbooking from './pages/Pune to Mumbai Online Cab Booking';
import Pimprichichwadtomumbaiacabservice from './pages/Pimpri Chinchwad to Mumbai Cab Service';
import Banertomumbaicab from './pages/Baner to Mumbai Cabs';
import Hinjewaditomumbaicabservice from './pages/Hinjewadi to Mumbai Cab Service';
import Wakadtomumbaicabservice from './pages/Wakad to Mumbai Cab Service';
import Hadapsartomumbaicabservice from './pages/Hadapsar to Mumbai Cab Service';
import Kalyaninagartomumbaitaxiservice from './pages/Kalyani Nagar to Mumbai Taxi Service';
import Koregaonparktomumbaicabservice from './pages/Koregaon Park to Mumbai Cab Service';
import Kothrudtomumbaicabservice from './pages/Kothrud to Mumbai Cab Service';
import Kharaditomumbaicabservice from './pages/Kharadi to Mumbai Cab Service';
import Shivajinagartomumbaicabservice from './pages/Shivajinagar to Mumbai Cab Service';
import Punetomumbaiertigacabservice from './pages/Pune to Mumbai Ertiga Cab Service';
import Punetomumbaiinnovacrystacab from './pages/Pune to Mumbai Innova Crysta Cab';
import Punetomumbaisedancabservice from './pages/Pune to Mumbai Sedan Cab Service';
import Kondhwatomumbaicabservice from './pages/Kondhwa to Mumbai Cab Service';
import Vimannagartomumbaicabservice from './pages/Viman Nagar to Mumbai Cabs Service';
import Katrajtomumbaicbaservice from './pages/Katraj to Mumbai Cab Service';
import Punestationtomumbaicabservice from './pages/Pune Station to Mumbai Cabs Service';
import Alanditomumbaicabservice from './pages/Alandi to Mumbai Cabs Service';
import Wagholitomumbaicabservice from './pages/Wagholi to Mumbai Cab Service';
import Pimplesaugartomumbaicab from './pages/Pimple Saudagar to Mumbai Cab Service';
import Boatclubroadmumbaicab from './pages/Boat Club Road to Mumbai Cab';
import Vishrantwaditomumbaicab from './pages/Vishrantwadi to Mumbai Cab';
import Mumbaitopuneonewaycab from './pages/Mumbai to Pune One Way Cab';
import Innovacrystaonrentinpune from './pages/Innova Crysta on Rent in Pune';
import Punemumbaidailycabservice from './pages/Pune Mumbai Daily Cab Service';
import Innovacrystacabs from './pages/Innova Crysta Cabs -Taxi Booking in Pune';
import Punetomahabaleshwarinnovacab from './pages/Pune to Mahabaleshwar Innova Crysta Cab';
import Bookinnovacrystaforoutstationfrompune from './pages/Book Innova Crysta for Outstation From Pune';
import Innovacrystacabsforpuneairport from './pages/Innova Crysta Cabs for Pune Airport';
import Punetomumbaiairportinnovacrysta from './pages/Pune to Mumbai Airport Innova Crysta';
import Innovacrystacabforcorporateoffice from './pages/Innova Crysta Cab for Corporate Office';
import Mumbaiairporttopuneinnovacrystacabs from './pages/Mumbai Airport to Pune Innova Crysta Cabs';
import Punetoshirdiinnovacrystacarrental from './pages/Pune to Shirdi Innova Crysta Car Rental';
import Punetoaurangabadinnovacrystacabservice from './pages/Pune Aurangabad Innova Crysta Cab Service';
import Punetogoainnovacrystacabservicebooking from './pages/Pune to Goa Innova Crysta Cab Services Booking';
import Punetobangloreinnovacrystacab from './pages/Pune to Bangalore Innova Crysta Cab';
import Punetohyderabadinnova from './pages/Pune to Hyderabad Innova Crysta Rental Cab';
import Punetolavasainnovacab from './pages/Pune to Lavasa Innova Crysta Cab Booking';
import Punedarshaninnovacrysta from './pages/Pune Darshan Innova Crysta Cabs';
import Innovacrystacabsinpune from './pages/Innova Crysta Cabs in Pune';
import Innovacarrentalinpune from './pages/Innova Car Rental In Pune';
import Innovataxtiserviceinpune from './pages/Innova Taxi Service in Pune';
import Bookinnovaforoustation from './pages/Book Innova for Outstation Pune';
import Punetomahabaleshawarpanchgani from './pages/Pune to Mahabaleshwar Panchgani Innova Crysta Cabs';
import Punetooutstationinnovacrysta from './pages/Pune to Outstation Innova Crysta Booking';
import Punetomumbaiairportinnovacrystacar from './pages/Pune to Mumbai Airport Innova Crysta Car Rental';
import Punetodapoliinnovacrystacabservice from './pages/Pune to Dapoli Innova Crysta Cab Service';
import Punetoshirdiinovacrystacabs from './pages/Pune to Shirdi Innova Crysta Cabs';
import Punetopandharpurcrystacab from './pages/Pune to Pandharpur Crysta Cabs Service';
import Punetonashikinnovacrysta from './pages/Pune to Nashik Innova Crysta Taxi Service';
import Innovacrystapuneairport from './pages/Innova Crysta Pune Airport Taxi';
import Innovacrystacabforcorporate from './pages/Innova Crysta Cab for Corporate';
import Luxurycabsbookingpune from './pages/Luxury Cabs Booking Pune';
import Punetohyderabadinnovacrysta from './pages/Pune to Hyderabad Innova Crysta Taxi Fare';
import Punetosuratinnovacabbooking from './pages/Pune to Surat Innova Cabs Booking';
import Punetoindoreinnovacabinnova from './pages/Pune to Indore Innova Crysta Cabs Booking';
import Punetolocalinnovacrystacarrental from './pages/Pune Local Innova Crysta Car Rental';
import Punetolonavalainnovacrystacabstaxi from './pages/Pune to Lonavala Innova Crysta Cabs Taxi';
import Punetokohlapurinnovacrystacabservice from './pages/Pune to Kolhapur Innova Crysta Cab Service';
import Punetogoainnovacrystacabservice from './pages/Pune to Goa Innova Crysta Cab Service';
import Punetoratnagiriinnovacrystacar from './pages/Pune to Ratnagiri Innova Crysta Car Rental';
import Innovacrystacarhireforeventpune from './pages/Innova Crysta Car Hire for Events Pune';
import Innovacrystacarrentalinvimannagar from './pages/Innova Crysta Car Rental in Viman Nagar';
import Punetoalibauginnovacrystacabservice from './pages/Pune to Alibag Innova Crysta Cab Service';
import Punetorajshthaninnovacrysta from './pages/Pune to Rajasthan Innova Crysta Rental';
import Punetonagpurinnovacrystacarrental from './pages/Pune to Nagpur Innova Crysta Car Rental';
import Punetodarshaninnovacrystabooking from './pages/Pune Darshan Innova Crysta Booking';
import Punetobhimashankarinnovacrysta from './pages/Pune to Bhimashankar Innova Crysta Taxi Service';
import Punetoashtavinayakdarshaninnova from './pages/Pune to Ashtavinayak Darshan Innova Crysta Booking';
import Punetojyotilingayatra from './pages/Pune to Jyotirlinga Yatra Innova Crysta Cab';
import Punetotrimkedhwarcrystacab from './pages/Pune to Trimbakeshwar Innova Crysta Cab';
import Punetoadabasimagicainnova from './pages/Pune to Adlabs Imagica Innova Crysta Cab';
import Punetokonkandarshaninnova from './pages/Pune to Konkan Darshan Innova Crysta Cab';
import Punetoshegaoninnovacrysta from './pages/Pune to Shegaon Innova Crysta Cab Service';
import Punetomathereinnova from './pages/Pune to Matheran Innova Crysta Cab Booking';
import Exploreindiapanindoa from './pages/Explore India Pan India Innova Crysta Cab Booking Services';
import Faqs from './pages/Faqs';
import Punetogoacabs from './pages/Pune to Goa Cabs';
import Punetojyotilingadarshanpackage from './pages/Pune to Jyotirlinga Darshan Package';
import Punetoakkalkotcab from './pages/Pune to Akkalkot Cabs';
import Punetogrishneshwarjyotilinga from './pages/Pune to Grishneshwar Jyotirlinga Cab';
import Punetolonavalacab from './pages/Pune to Lonavala Cab';
import Punetogoacabservice from './pages/Pune to Goa Cab Service';
import Goatopunecabs from './pages/Goa to Pune Cabs';
import Ertigaonrentinpune from './pages/Ertiga On Rent in Pune';
import Punetoshrivardhancab from './pages/Pune to Shrivardhan Cab';
import Punetojyotiba from './pages/Pune to Jyotiba Cab';
import Punetoujjaincab from './pages/Pune to Ujjain Cab';
import Punetoshirdicab from './pages/Pune to Shirdi Cab';
import Mumbaitogoacabs from './pages/Mumbai to Goa Cab';
import Mumbaitoalibaugcabservice from './pages/Mumbai to Alibaug Cab Service';
import Bestcabserviceinpune from './pages/Best Cab Service in Pune';
import Onlinecabbookingpune from './pages/Online Cab Booking Pune';

function App() {




  return (
    <Router>
      <Header/>
      <ScrollToTop/>
      <ContactButtons/>

      <Routes>

        <Route path="/" element={<HeroSection />} />
        <Route path="/about" element={<About />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/services" element={<BookingBannerSection />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/our-fleet" element={<Ourfleet />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/contact-us" element={<ContactSection />} />
        <Route path="/enquiry" element={<Enquiry />} />
       
<Route path="/Online-Cab-Booking-In-Pune" element={<Onlinecabbookinginpune />} />
<Route path="/Pune-To-Kolhapur-Cab" element={<Punetokolhapurcab />} />
<Route path="/Pune-To-Satara-Cab" element={<Punetosataracab />} />
<Route path="/Pune-To-Hyderabad-Cab" element={<Punetohyderabad />} />
<Route path="/Pune-To-Bangalore-Cab" element={<Punetobanglorecab />} />
<Route path="/Pune-To-Indore-Cab" element={<Punetoindorecab />} />
<Route path="/Pune-To-Gujarat-Cab" element={<Punetogujratcab />} />
<Route path="/Pune-To-Lonavala-Taxi" element={<Punetolonavala />} />
<Route path="/Pune-To-Jejuri-Cab" element={<Punetojejuricab />} />
<Route path="/Local-Taxi-Service-In-Pune" element={<Localtaxiserviceinpune />} />
<Route path="/Book-Pune-To-Lavasa-Cab" element={<Punetolavasacab />} />
<Route path="/Pune-To-Kashid-Beach-Cab" element={<Punetokashidbeach />} />
<Route path="/One-Way-Cab-Pune" element={<Onewaycabpune />} />
<Route path="/Round-Trip-Cab" element={<Roundtripcab />} />
<Route path="/Taxi-Service-Near-Me" element={<Taxiservicenearme />} />
<Route path="/Car-Hire-In-Pune" element={<Carhireinpune />} />
<Route path="/Seater-Car-On-Rent-In-Pune" element={<Seatercarrentalinpune />} />
<Route path="/Cab-Service-In-Pimpri-Chinchwad" element={<Cabserviceinpimprichichwad />} />


<Route path="/Pune-Taxi-Cab-Services" element={<Punetotaxicabservice />} />
<Route path="/Pune-Airport-Taxi" element={<Puneairporttaxi />} />
<Route path="/Pune-To-Rajasthan-Cab" element={<Punetorajshthancab />} />
<Route path="/Pune-To-Matheran-Cab" element={<Punetomatherancab />} />
<Route path="/Pune-To-Pandharpur-Cab" element={<Punetopandharpurcab />} />
<Route path="/Pune-To-Mumbai-Cabs" element={<Punetomumbaicabs />} />
<Route path="/Pune-To-Mumbai-Airport-Cab" element={<Punetomumbaiairportcab />} />
<Route path="/Pune-To-Mumbai-Taxi" element={<Punetomumbaitaxi />} />
<Route path="/Mumbai-To-Pune-Cab" element={<Mumbaitopunecab />} />
<Route path="/Mumbai-Airport-To-Pune-Cab" element={<Mumbaiairporttopunecab />} />
<Route path="/Dadar-To-Pune-Cab-Service" element={<Dadartopunecabservice />} />
<Route path="/Bandra-To-Pune-Cab" element={<Bandratopunecabs />} />
<Route path="/Pune-To-Outstation-Cab" element={<Punrtooutstationcab />} />
<Route path="/Taxi-Service-In-Pune" element={<Taxiserviceinpune />} />
<Route path="/Pune-To-Shirdi-Taxi-Fare" element={<Punetoshirditaxifare />} />
<Route path="/Pune-Airport-To-Shirdi-Cab" element={<Puneairporttoshirdicab />} />
<Route path="/Pune-To-Nashik-Cab" element={<Punetonashikcab />} />
<Route path="/Pune-To-Bhimashankar-Cab" element={<Punetobhimashankarcab />} />


<Route path="/Pune-To-Trimbakeshwar-Cab-Fare" element={<Punetotrimbakeshwarcab />} />
<Route path="/Pune-To-Mahabaleshwar-Cab" element={<Punetomahabaleshwarcab />} />
<Route path="/Book-Pune-To-Panchgani-Cab" element={<Punetopanchganicab />} />
<Route path="/Pune-To-Ahmednagar-Cab" element={<Punetoahmednagarcab />} />
<Route path="/Pune-To-Goa-Taxi" element={<Punetogoataxi />} />
<Route path="/Pune-To-Alibaug-Cab" element={<Punetoalibaugcab />} />
<Route path="/Pune-To-Ashtavinayak-Cab" element={<Punetoashtavinayakcab />} />
<Route path="/Pune-To-Aurangabad-Cab" element={<Punetoaurangabadcab />} />
<Route path="/Andheri-To-Pune-Cab" element={<Andheritopunecab />} />
<Route path="/Borivali-To-Pune-Cab" element={<Borivalitopunecab />} />
<Route path="/Mumbai-To-Lonavala-Cab" element={<Mumbaitolonavalacab />} />
<Route path="/Navi-Mumbai-To-Pune-Cab" element={<Navimumbaitopunecab />} />
<Route path="/Thane-To-Pune-Cab" element={<Thanetopunecab />} />
<Route path="/Sedan-Cab-Service-In-Pune" element={<Sedancabserviceinpune />} />
<Route path="/Innova-Crysta-Cab-Booking" element={<Innovacrystacabbooking />} />
<Route path="/Ertiga-Cab-Pune" element={<Ertigacabpune />} />
<Route path="/Tempo-Traveller-On-Rent-Pune" element={<Tempotravelleeronrentinpune />} />
<Route path="/Mini-Bus-On-Rent" element={<Minibusonrent />} />

<Route path="/Pune-To-Mumbai-International-Airport-Cab" element={<Punetomumbaiinternatinalairport />} />
<Route path="/Pune-To-Mumbai-One-Way-Cab-Service" element={<Punetomumbaionewaycabservice />} />
<Route path="/Pune-Mumbai-Car-Hire" element={<Punetomumbaicarhire />} />
<Route path="/Pune-To-Mumbai-Taxi-Fare" element={<Punetomumbaitaxifare />} />
<Route path="/Pune-To-Mumbai-Online-Cab-Booking" element={<Punetomumbaionlinecabbooking />} />
<Route path="/Pimpri-Chinchwad-To-Mumbai-Cab-Service" element={<Pimprichichwadtomumbaiacabservice />} />
<Route path="/Baner-To-Mumbai-Cabs" element={<Banertomumbaicab />} />
<Route path="/Hinjewadi-To-Mumbai-Cab-Service" element={<Hinjewaditomumbaicabservice />} />
<Route path="/Wakad-To-Mumbai-Cab-Service" element={<Wakadtomumbaicabservice />} />
<Route path="/Hadapsar-To-Mumbai-Cab-Service" element={<Hadapsartomumbaicabservice />} />
<Route path="/Kalyani-Nagar-To-Mumbai-Taxi-Service" element={<Kalyaninagartomumbaitaxiservice />} />
<Route path="/Koregaon-Park-To-Mumbai-Cab-Service" element={<Koregaonparktomumbaicabservice />} />
<Route path="/Kothrud-To-Mumbai-Cab-Service" element={<Kothrudtomumbaicabservice />} />
<Route path="/Kharadi-To-Mumbai-Cab-Service" element={<Kharaditomumbaicabservice />} />
<Route path="/Shivajinagar-To-Mumbai-Cab-Service" element={<Shivajinagartomumbaicabservice />} />
<Route path="/Pune-To-Mumbai-Ertiga-Cab-Service" element={<Punetomumbaiertigacabservice />} />
<Route path="/Pune-To-Mumbai-Innova-Crysta-Cab" element={<Punetomumbaiinnovacrystacab />} />
<Route path="/Pune-To-Mumbai-Sedan-Cab-Service" element={<Punetomumbaisedancabservice />} />
<Route path="/Kondhwa-To-Mumbai-Cab-Service" element={<Kondhwatomumbaicabservice />} />
<Route path="/Viman-Nagar-To-Mumbai-Cabs-Service" element={<Vimannagartomumbaicabservice />} />
<Route path="/Katraj-To-Mumbai-Cab-Service" element={<Katrajtomumbaicbaservice />} />
<Route path="/Pune-Station-To-Mumbai-Cabs-Service" element={<Punestationtomumbaicabservice />} />
<Route path="/Alandi-To-Mumbai-Cabs-Service" element={<Alanditomumbaicabservice />} />
<Route path="/Wagholi-To-Mumbai-Cab-Service" element={<Wagholitomumbaicabservice />} />
<Route path="/Pimple-Saudagar-To-Mumbai-Cab-Service" element={<Pimplesaugartomumbaicab />} />
<Route path="/Boat-Club-Road-To-Mumbai-Cab" element={<Boatclubroadmumbaicab />} />
<Route path="/Vishrantwadi-To-Mumbai-Cab" element={<Vishrantwaditomumbaicab />} />
<Route path="/Mumbai-To-Pune-One-Way-Cab" element={<Mumbaitopuneonewaycab />} />
<Route path="/Innova-Crysta-On-Rent-In-Pune" element={<Innovacrystaonrentinpune />} />
<Route path="/Pune-Mumbai-Daily-Cab-Service" element={<Punemumbaidailycabservice />} />




<Route path="/Innova-Crysta-Cabs-Taxi-Booking-In-Pune" element={<Innovacrystacabs />} />
<Route path="/Pune-To-Mahabaleshwar-Innova-Crysta-Cab" element={<Punetomahabaleshwarinnovacab />} />
<Route path="/Book-Innova-Crysta-For-Outstation-From-Pune" element={<Bookinnovacrystaforoutstationfrompune />} />
<Route path="/Innova-Crysta-Cabs-For-Pune-Airport" element={<Innovacrystacabsforpuneairport />} />
<Route path="/Pune-To-Mumbai-Airport-Innova-Crysta" element={<Punetomumbaiairportinnovacrysta />} />
<Route path="/Innova-Crysta-Cab-For-Corporate-Office" element={<Innovacrystacabforcorporateoffice />} />
<Route path="/Mumbai-Airport-To-Pune-Innova-Crysta-Cabs" element={<Mumbaiairporttopuneinnovacrystacabs />} />
<Route path="/Pune-To-Shirdi-Innova-Crysta-Car-Rental" element={<Punetoshirdiinnovacrystacarrental />} />
<Route path="/Pune-Aurangabad-Innova-Crysta-Cab-Service" element={<Punetoaurangabadinnovacrystacabservice />} />
<Route path="/Pune-To-Goa-Innova-Crysta-Cab-Services-Booking" element={<Punetogoainnovacrystacabservicebooking />} />
<Route path="/Pune-To-Bangalore-Innova-Crysta-Cab" element={<Punetobangloreinnovacrystacab />} />
<Route path="/Pune-To-Hyderabad-Innova-Crysta-Rental-Cab" element={<Punetohyderabadinnova />} />
<Route path="/Pune-To-Lavasa-Innova-Crysta-Cab-Booking" element={<Punetolavasainnovacab />} />
<Route path="/Pune-Darshan-Innova-Crysta-Cabs" element={<Punedarshaninnovacrysta />} />
<Route path="/Innova-Crysta-Cabs-In-Pune" element={<Innovacrystacabsinpune />} />
<Route path="/Innova-Car-Rental-In-Pune" element={<Innovacarrentalinpune />} />
<Route path="/Innova-Taxi-Service-In-Pune" element={<Innovataxtiserviceinpune />} />
<Route path="/Book-Innova-For-Outstation-Pune" element={<Bookinnovaforoustation />} />
<Route path="/Pune-To-Mahabaleshwar-Panchgani-Innova-Crysta-Cabs" element={<Punetomahabaleshawarpanchgani />} />
<Route path="/Pune-To-Outstation-Innova-Crysta-Booking" element={<Punetooutstationinnovacrysta />} />
<Route path="/Pune-To-Mumbai-Airport-Innova-Crysta-Car-Rental" element={<Punetomumbaiairportinnovacrystacar />} />
<Route path="/Pune-To-Dapoli-Innova-Crysta-Cab-Service" element={<Punetodapoliinnovacrystacabservice />} />
<Route path="/Pune-To-Shirdi-Innova-Crysta-Cabs" element={<Punetoshirdiinovacrystacabs />} />
<Route path="/Pune-To-Pandharpur-Crysta-Cabs-Service" element={<Punetopandharpurcrystacab />} />
<Route path="/Pune-To-Nashik-Innova-Crysta-Taxi-Service" element={<Punetonashikinnovacrysta />} />
<Route path="/Innova-Crysta-Pune-Airport-Taxi" element={<Innovacrystapuneairport />} />
<Route path="/Innova-Crysta-Cab-For-Corporate" element={<Innovacrystacabforcorporate />} />
<Route path="/Luxury-Cabs-Booking-Pune" element={<Luxurycabsbookingpune />} />
<Route path="/Pune-To-Hyderabad-Innova-Crysta-Taxi-Fare" element={<Punetohyderabadinnovacrysta />} />
<Route path="/Pune-To-Surat-Innova-Cabs-Booking" element={<Punetosuratinnovacabbooking />} />
<Route path="/Pune-To-Indore-Innova-Crysta-Cabs-Booking" element={<Punetoindoreinnovacabinnova />} />
<Route path="/Pune-Local-Innova-Crysta-Car-Rental" element={<Punetolocalinnovacrystacarrental />} />
<Route path="/Pune-To-Lonavala-Innova-Crysta-Cabs-Taxi" element={<Punetolonavalainnovacrystacabstaxi />} />
<Route path="/Pune-To-Kolhapur-Innova-Crysta-Cab-Service" element={<Punetokohlapurinnovacrystacabservice />} />
<Route path="/Pune-To-Goa-Innova-Crysta-Cab-Service" element={<Punetogoainnovacrystacabservice />} />
<Route path="/Pune-To-Ratnagiri-Innova-Crysta-Car-Rental" element={<Punetoratnagiriinnovacrystacar />} />
<Route path="/Innova-Crysta-Car-Hire-For-Events-Pune" element={<Innovacrystacarhireforeventpune />} />
<Route path="/Innova-Crysta-Car-Rental-In-Viman-Nagar" element={<Innovacrystacarrentalinvimannagar />} />
<Route path="/Pune-To-Alibag-Innova-Crysta-Cab-Service" element={<Punetoalibauginnovacrystacabservice />} />
<Route path="/Pune-To-Rajasthan-Innova-Crysta-Rental" element={<Punetorajshthaninnovacrysta />} />
<Route path="/Pune-To-Nagpur-Innova-Crysta-Car-Rental" element={<Punetonagpurinnovacrystacarrental />} />
<Route path="/Pune-Darshan-Innova-Crysta-Booking" element={<Punetodarshaninnovacrystabooking />} />
<Route path="/Pune-To-Bhimashankar-Innova-Crysta-Taxi-Service" element={<Punetobhimashankarinnovacrysta />} />
<Route path="/Pune-To-Ashtavinayak-Darshan-Innova-Crysta-Booking" element={<Punetoashtavinayakdarshaninnova />} />
<Route path="/Pune-To-Jyotirlinga-Yatra-Innova-Crysta-Cab" element={<Punetojyotilingayatra />} />
<Route path="/Pune-To-Trimbakeshwar-Innova-Crysta-Cab" element={<Punetotrimkedhwarcrystacab />} />
<Route path="/Pune-To-Adlabs-Imagica-Innova-Crysta-Cab" element={<Punetoadabasimagicainnova />} />
<Route path="/Pune-To-Konkan-Darshan-Innova-Crysta-Cab" element={<Punetokonkandarshaninnova />} />
<Route path="/Pune-To-Shegaon-Innova-Crysta-Cab-Service" element={<Punetoshegaoninnovacrysta />} />
<Route path="/Pune-To-Matheran-Innova-Crysta-Cab-Booking" element={<Punetomathereinnova />} />
<Route path="/Explore-India-Pan-India-Innova-Crysta-Cab-Booking-Services" element={<Exploreindiapanindoa />} />






<Route path="/Pune-To-Goa-Cabs" element={<Punetogoacabs />} />
<Route path="/Pune-To-Jyotirlinga-Darshan-Package" element={<Punetojyotilingadarshanpackage />} />
<Route path="/Pune-To-Akkalkot-Cabs" element={<Punetoakkalkotcab />} />
<Route path="/Pune-To-Grishneshwar-Jyotirlinga-Cab" element={<Punetogrishneshwarjyotilinga />} />
<Route path="/Pune-To-Lonavala-Cab" element={<Punetolonavalacab />} />
<Route path="/Pune-To-Alibag-Cab" element={<Punetoalibaugcab />} />
<Route path="/Pune-To-Goa-Cab-Service" element={<Punetogoacabservice />} />
<Route path="/Goa-To-Pune-Cabs" element={<Goatopunecabs />} />
<Route path="/Ertiga-On-Rent-In-Pune" element={<Ertigaonrentinpune />} />
<Route path="/Pune-To-Shrivardhan-Cab" element={<Punetoshrivardhancab />} />


<Route path="/Pune-To-Jyotiba-Cab" element={<Punetojyotiba />} />
<Route path="/Pune-To-Ujjain-Cab" element={<Punetoujjaincab />} />
<Route path="/Pune-To-Shirdi-Cab" element={<Punetoshirdicab />} />
<Route path="/Mumbai-To-Goa-Cab" element={<Mumbaitogoacabs />} />
<Route path="/Mumbai-To-Alibaug-Cab-Service" element={<Mumbaitoalibaugcabservice />} />
<Route path="/Best-Cab-Service-In-Pune" element={<Bestcabserviceinpune />} />
<Route path="/Online-Cab-Booking-Pune" element={<Onlinecabbookingpune />} />




      </Routes>
     <Footer/>
    </Router>
  );
}



export default App;
